function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
export var activeModules = [];
export var kobiEvents = {
  'cartUpdate': {
    'async': true,
    'description': 'Add to cart event, exepected data: listProducts object array, each object is a product',
    'data': ['listProducts']
  },
  'context': {
    'async': false,
    'description': 'Change contextualization shop',
    'data': ['idMag']
  },
  'componentTcVarsReady': {
    'async': false,
    'description': 'Fired when TMS component data are ready to send',
    'data': ['tcvars']
  },
  'componentJsonldReady': {
    'async': true,
    'description': 'Fired when Jsonld component data are ready to send',
    'data': ['jsonld']
  },
  'userInfoAvailable': {
    'async': true,
    'description': 'Fired when user data are available (API fallback or cache)',
    'data': ['userInfo']
  },
  'selectedFilters': {
    'async': true,
    'description': 'Fired when user selects a filter in family product pages',
    'data': ['filters']
  },
  'personalData': {
    'async': true,
    'description': 'Fired when user clics the contact form link in CGU page',
    'data': ['button']
  },
  'productSoldOnWeb': {
    'async': true,
    'description': 'Fired if product is sold online and can be added to cart. Send ONLY if it\'s available online.',
    'data': ['product']
  },
  'refreshTcVars': {
    'async': true,
    'description': 'To fire only when [data-tcvars] values have changed in ajax (such as filter, pagination, ...) in order to rebuild and send the new tcVars'
  },
  'customerDetails': {
    'async': true,
    'description': 'Fired from customer-address module for any other component that uses it (reservation...)',
    'data': ['infos']
  },
  'waitDataLayerFragment': {
    'async': false,
    'description': 'Fired when TMS component have to wait for data to be ready',
    'data': ['id']
  },
  'userConsentGiven': {
    'async': true,
    'description': 'Fired when user choice on privacy policy is given',
    'data': ['isConsentGiven']
  },
  'userAutoContextSuccess': {
    'async': true,
    'description': 'Fired when auto context succeed',
    'data': ['isUserAutoContextSuccess']
  }
};
export var Composant = /*#__PURE__*/_createClass(function Composant(id) {
  var noHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  _classCallCheck(this, Composant);
  // On teste si l'attirbut noHTML est passé en paramètre à true, si c'estle cas, c'est un composant non visuel (TMS...)
  if (!noHTML) {
    // On récupère toutes les sections qui ont cet ID
    var modulesKobi = document.querySelectorAll("[id^=component-".concat(id, "], header[id^=").concat(id, "], footer[id^=").concat(id, "]"));

    // On Boucle dans chaque élément trouvé
    // --> Il est possible d'avoir plusieurs composants identiques ( produits-complementaire-1, produits-complementaire-2, ... )
    for (var i = 0; i < modulesKobi.length; i++) {
      // On vérifie si cet élément en particulier a déjà été instancié
      var alreadyExist = false;
      for (var j = activeModules.length - 1; j >= 0; j--) {
        if (activeModules[j].id === modulesKobi[i].id) {
          alreadyExist = true;
        }
      }

      // Si cette section n'est pas encore init, on le fait
      if (!alreadyExist) {
        this.target = modulesKobi[i];
        this.id = modulesKobi[i].id;
        break;
      }
    }

    // Si on a pas trouvé de composant HTML correspondant
    if (!this.target) {
      console.warn("Le module <".concat(id, "> n'existe pas dans la page ou a d\xE9j\xE0 \xE9t\xE9 instanci\xE9."));
    }

    // On documente la liste des modules instanciés
    // activeModules.push(this);
    activeModules.push({
      'id': this.id,
      'target': this.target
    });
    if (performance.mark !== undefined) {
      performance.mark("Component ".concat(id, " ready"));
    }
    // eslint-disable-next-line
    console.log("Le module <".concat(id, "> a \xE9t\xE9 instanci\xE9."));
  }

  // On ajoute à l'instance les fonctions d'events
  for (var event in kobiEvents) {
    addLMEvent.call(this, event);
  }

  // Les éléments spécifiques à un site peuvent être injecté dans le constructeur via cette méthode
  // `Composant.prototype.customExtend = function(){...}`
  if (this.customExtend) {
    this.customExtend.call(this);
  }
});
var addLMEvent = function addLMEvent(eventName) {
  var _this = this;
  var async = kobiEvents[eventName].async;
  var dataValidation = kobiEvents[eventName].data;
  this[eventName] = function (data) {
    // Validation des paramètres obligatoire
    for (var i = 0; i < dataValidation.length; i++) {
      if (typeof data[dataValidation[i]] === 'undefined') {
        console.error("Le param <".concat(dataValidation[i], "> est manquant"));
        return;
      }
    }

    // Création de l'événement
    data.emitterId = _this.id;
    var event = new CustomEvent(eventName, {
      detail: data
    });

    // Gestion sync/async
    if (async) {
      setTimeout(function () {
        document.dispatchEvent(event);
      }, 1);
    } else {
      document.dispatchEvent(event);
    }
  };

  // la fonction est une CONST
  Object.defineProperty(this, eventName, {
    writable: false
  });
};